module.exports = __webpack_public_path__ + "sansg/img/mountaineer-2080138.fb22a644.png";